/**
 * * Модель запроса на отправку чанков файла
 */
export default class SendFileChunkRequest  {
	/**
	 * * Чанк файла
	 */
	FileChunk!: string;
	/**
	 * * Номер файла
	 */
	FileId!: number;
	/**
	 * * Номер загрузки файла
	 */
	UploadId!: string;
	/**
	 * * Номер части файла
	 */
	PartNumber!: number;
	constructor(obj?: Partial<SendFileChunkRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
